import { getAllCategories } from './categories';

interface SupermarketData {
  zones?: Array<{
    categoryMappings?: Array<{
      categoryName: string;
    }>;
  }>;
}

/**
 * Extracts custom categories from a supermarket and saves them to localStorage
 * for persistent availability across all users who interact with this supermarket.
 */
export function extractAndSaveCustomCategories(supermarket: SupermarketData | null | undefined): void {
  if (!supermarket?.zones) return;

  // Extract all categories from supermarket zones
  const categoriesFromSupermarket = supermarket.zones
    .flatMap(zone => zone.categoryMappings?.map(cm => cm.categoryName) || []);
  
  const uniqueCategories = [...new Set(categoriesFromSupermarket)];

  // Filter out standard categories
  const standardCategories = getAllCategories().map(([name]) => name);
  const customCategories = uniqueCategories.filter(cat => !standardCategories.includes(cat));

  if (customCategories.length === 0) return;

  // Merge with existing localStorage categories
  const savedCategories = localStorage.getItem('customCategories');
  const localCategories = savedCategories ? JSON.parse(savedCategories) : [];
  const mergedCategories = [...new Set([...localCategories, ...customCategories])].sort();

  // Save back to localStorage
  localStorage.setItem('customCategories', JSON.stringify(mergedCategories));
}
